export default __webpack_public_path__ + "static/media/video-horizontal-background-0004.a56db125.jpg";